import React, {MouseEvent} from 'react'

type ButtonType = 'primary' | 'alt' | 'link' | 'file' | 'danger'

interface ButtonProps {
    className?: string
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void
    icon?: React.ReactElement | string
    iconPosition?: 'left' | 'right'
    iconClassName?: string
    size?: 'sm' | 'md' | 'lg'
    disabled?: boolean
    children?: React.ReactElement | string
    type?: ButtonType
    title?: string
}

const Button: React.FC<ButtonProps> = (
    {
        className,
        onClick,
        icon,
        size = 'md',
        disabled = false,
        children: label,
        iconPosition = 'left',
        type = 'primary',
        iconClassName = '',
        title,
    }
) => {
    // Define size classes for Tailwind CSS
    const sizeClasses = {
        sm: 'h-[37px]  gap-sm px-sm py-[0px] text-title-md',
        md: 'h-[44px]  gap-sm px-md py-[0px] text-title-md',
        lg: 'h-[50px]  gap-md px-lg py-[0px] text-title-lg',
    }

    // Define type classes for Tailwind CSS

    const typeClasses = {
        primary: `text-white border-primary-600 bg-primary-500  ${
            !disabled
                ? ' active:shadow-focus active:bg-primary-600 active:border-primary-700 hover:bg-primary-600 focus:bg-primary-600 '
                : ''
        } `,
		danger: `text-white border-red-600 bg-red-500 ${
			!disabled
				? ' active:shadow-red active:bg-red-600 active:border-red-700 hover:bg-red-600 focus:bg-red-600 '
				: ''
		} `,
        alt: `text-primary-700 border-primary-400 bg-primary-25  ${
            !disabled ? 'hover:border-primary-500 focus:border-primary-500 active:shadow-focus active:bg-white' : ''
        }`,
        link: `text-primary-600  h-[auto] px-0 py-0 gap-xs ${
            !disabled ? 'hover:text-gray-900 focus:text-gray-900 active:text-primary-800' : ''
        }`
        ,
        file: `transition  h-[auto] flex flex-col gap-xs  bg-white rounded-md border border-dashed border-gray-200 justify-center items-center hover:border-primary-500 ${
            !disabled ? 'hover:text-gray-900 focus:text-gray-900 active:text-primary-800' : ''
        }`,
    }

    const typeClassesDisabled = {
        primary: 'border-gray-400 bg-gray-300 text-white ',
        alt: 'text-gray-300 border-gray-300 bg-gray-25',
        link: 'text-gray-300 h-[auto] px-0 py-0 gap-xs',
        file: 'text-gray-300 h-[auto] px-0 py-0 gap-xs',
		danger: 'border-gray-400 bg-gray-300 text-white '
    }

    return (
        <button
            className={` 
                select-none whitespace-nowrap text-wrap flex-row flex   transition-all outline-none ${
                !disabled ? 'active:z-[2] focus:outline-none  focus:z-[2]' : ''
            } 
                ${
                (type !== 'link' && type !== 'file')
                    ? `justify-center  items-center rounded-md border shadow-xs ${
                        !disabled ? 'focus:shadow-focus' : ''
                    }`
                    : ''
            }
                ${type === 'primary' ? 'text-shadow-sm' : ''}
                
                ${disabled ? 'cursor-default ' : ''} 
                ${sizeClasses[size] || sizeClasses['md']}
                ${!disabled && (typeClasses[type] || typeClasses['primary'])}
                ${disabled && (typeClassesDisabled[type] || typeClassesDisabled['primary'])} 
                ${className}
            `}
            onClick={onClick}
            disabled={disabled}
            title={title}
            onMouseUp={(e) => e.currentTarget.blur()}
            onTouchEnd={(e) => e.currentTarget.blur()}
        >
            {icon && iconPosition === 'left' && (
                <span className={`font-icon-regular flex shrink-0 items-center justify-center ${iconClassName}`}>{icon}</span>
            )}
			{label ? <div className="flex flex-row items-center gap-xs">{label}</div> : null}
            {icon && iconPosition === 'right' && (
                <span className={`font-icon-regular flex shrink-0 items-center justify-center ${iconClassName}`}>{icon}</span>
            )}
        </button>
    )
}

export default Button
